module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-table', {
    attrs: {
      "data": _vm.data,
      "columns": _vm.columns
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53ed3b50"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/table/examples/ExSearchable.vue
// module id = 1207
// module chunks = 1 85